import script from "./MaterialBankPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialBankPage.vue?vue&type=script&setup=true&lang=js"

import "./MaterialBankPage.vue?vue&type=style&index=0&id=4ab9d54e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ab9d54e"]])

export default __exports__